import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2fa92e1b&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=2fa92e1b&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=2fa92e1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa92e1b",
  null
  
)

export default component.exports